export enum BaseTimeUnit {
  Hour = `hour`,
  Day = `day`,
  Week = `week`,
  Month = `month`,
}

export enum ExtendedTimeUnit {
  Second = `second`,
  Minute = `minute`,
  Quarter = `quarter`,
  Year = `year`,
}

export type StandardTimeUnit = BaseTimeUnit | ExtendedTimeUnit;

export enum NonStandardTimeUnit {
  Session = `session`,
}

export const TimeUnit = Object.assign(BaseTimeUnit, ExtendedTimeUnit, NonStandardTimeUnit);
export type TimeUnit = StandardTimeUnit | NonStandardTimeUnit;
export const OrderedStandardTimeUnits: StandardTimeUnit[] = [
  TimeUnit.Minute,
  TimeUnit.Hour,
  TimeUnit.Day,
  TimeUnit.Week,
  TimeUnit.Month,
  TimeUnit.Quarter,
  TimeUnit.Year,
];

export enum SpecialTimeUnit {
  HourOfDay = `hour_of_day`,
  DayOfWeek = `day_of_week`,
}

/* eslint-disable @typescript-eslint/naming-convention */
export enum TimeUnitLabels {
  minute = `Minute`,
  hour = `Hour`,
  day = `Day`,
  week = `Week`,
  month = `Month`,
  quarter = `Quarter`,
  year = `Year`,
  hour_of_day = `Hour of Day`,
  day_of_week = `Day of Week`,
  session = `Session`,
  second = `Second`,
}
/* eslint-enable */

export interface RelativeDate {
  unit: TimeUnit;
  value: number;
}

/** format: "YYYY-MM-dd" */
export type AbsoluteDate = string;

export type BaseDate = AbsoluteDate | RelativeDate;

export interface ApiDateRange {
  before?: boolean;
  from_date?: BaseDate;
  to_date?: BaseDate;
  window?: RelativeDate;
}

export interface BookmarkDateRange {
  type: DateRangeType;
  from_date: BaseDate;
  to_date: BaseDate;
}

export interface CalendarDateRange {
  from?: AbsoluteDate;
  to?: AbsoluteDate;
}

export enum DateRangeType {
  Between = `between`,
  NotBetween = `not between`,
  On = `on`,
  NotOn = `not on`,
  RelativeAfter = `in the last`,
  NotRelativeAfter = `not in the last`,
  RelativeBefore = `before the last`,
  RelativeFuture = `in the next`,
  Since = `since`,
  Before = `before`,
  StartsOn = `starts on`,
  EndsOn = `ends on`,
}

export enum DisplayContext {
  Default = `default`,
  FullLength = `full_length`,
  ImpactTimePicker = `impact_time_picker`,
  InsightsTimePicker = `insights_time_picker`,
  PropertyFilter = `property_filter`,
  RelativeRange = `relative_range`,
}
